// Localized copy for the Articles hub, category, and article pages.
// Keeping content here means the routes stay thin wrappers.

export const HUB_DICT_EN = {
  eyebrow: "Banana Cards Articles",
  title: "Ideas, playbooks, and",
  titleItalic: "growth stories",
  intro:
    "Deep-dive articles on lead generation, CRM strategy, networking, and building a business you can actually scale — written by our team and the operators who use Banana Cards every day.",
  searchPlaceholder: "Search articles, topics, or keywords…",
  seoLead: "The best place to learn modern selling",
  seoP1:
    "Banana Cards Articles is where founders, sales leaders, and modern professionals come to level up. Every guide is written to answer one clear question — no fluff, no listicles pretending to be strategy.",
  seoP2:
    "From cold outreach playbooks and AI-powered lead generation, to networking at events and running a full CRM inside Banana Cards, everything is designed to help you close more deals and grow faster.",
  featured: "Featured article",
  featuredCta: "Read the full article",
  browseEyebrow: "Browse by topic",
  browseTitle: "Explore every",
  browseTitleItalic: "category",
  seeAll: (name: string) => `See all ${name}`,
  emptyTitle: "Articles coming soon",
  emptyBody: "We're publishing new pieces every week — check back shortly.",
  ctaEyebrow: "Try Banana Cards",
  ctaTitle: "Turn reading into",
  ctaTitleItalic: "revenue",
  ctaBody:
    "Every playbook you read here is built on top of the Banana Cards platform. Create your free account and start applying it today.",
  ctaPrimary: "Get started free",
  ctaSecondary: "Browse more articles",
  articlesCount: (n: number) => (n === 1 ? "1 article" : `${n} articles`),
  minRead: (m: number) => `${m} min read`,
  by: "By",
  whyBanana: "Why Banana Cards Articles",
  whyBananaP: "",
  writtenByExperts: "Written by operators",
  writtenByExpertsP: "Not generic content — real playbooks from teams shipping today.",
  updatedRegularly: "Kept fresh",
  updatedRegularlyP: "New guides every week, with older articles updated as tactics evolve.",
  actionable: "Actionable, always",
  actionableP: "Every article ends with steps you can execute inside Banana Cards.",
};

export const HUB_DICT_VI: typeof HUB_DICT_EN = {
  eyebrow: "Bài viết Banana Cards",
  title: "Ý tưởng, quy trình và",
  titleItalic: "câu chuyện tăng trưởng",
  intro:
    "Các bài viết chuyên sâu về tìm kiếm khách hàng, chiến lược CRM, xây dựng mạng lưới và phát triển doanh nghiệp — do đội ngũ của chúng tôi và những người dùng Banana Cards hàng ngày chia sẻ.",
  searchPlaceholder: "Tìm bài viết, chủ đề hoặc từ khoá…",
  seoLead: "Nơi tốt nhất để học bán hàng hiện đại",
  seoP1:
    "Banana Cards Articles là nơi các nhà sáng lập, lãnh đạo bán hàng và những người làm nghề chuyên nghiệp đến để nâng cấp bản thân. Mỗi hướng dẫn đều trả lời một câu hỏi rõ ràng — không lan man, không danh sách rỗng tuếch.",
  seoP2:
    "Từ các kịch bản cold outreach, tìm kiếm khách hàng bằng AI, đến kết nối tại sự kiện và vận hành toàn bộ CRM trong Banana Cards, tất cả đều được thiết kế để giúp bạn chốt được nhiều đơn hơn và phát triển nhanh hơn.",
  featured: "Bài viết nổi bật",
  featuredCta: "Đọc toàn bộ bài viết",
  browseEyebrow: "Duyệt theo chủ đề",
  browseTitle: "Khám phá mọi",
  browseTitleItalic: "danh mục",
  seeAll: (name: string) => `Xem tất cả ${name}`,
  emptyTitle: "Sắp có bài viết mới",
  emptyBody: "Chúng tôi đăng bài mới mỗi tuần — hãy quay lại sớm nhé.",
  ctaEyebrow: "Dùng thử Banana Cards",
  ctaTitle: "Biến việc đọc thành",
  ctaTitleItalic: "doanh thu",
  ctaBody:
    "Mỗi kịch bản bạn đọc ở đây đều được xây trên nền tảng Banana Cards. Tạo tài khoản miễn phí và bắt đầu áp dụng ngay hôm nay.",
  ctaPrimary: "Bắt đầu miễn phí",
  ctaSecondary: "Xem thêm bài viết",
  articlesCount: (n: number) => (n === 1 ? "1 bài viết" : `${n} bài viết`),
  minRead: (m: number) => `${m} phút đọc`,
  by: "Bởi",
  whyBanana: "Vì sao Banana Cards Articles",
  whyBananaP: "",
  writtenByExperts: "Viết bởi người thực chiến",
  writtenByExpertsP: "Không phải nội dung chung chung — quy trình thật từ các đội đang triển khai.",
  updatedRegularly: "Luôn cập nhật",
  updatedRegularlyP: "Bài mới mỗi tuần, bài cũ được cập nhật khi chiến thuật thay đổi.",
  actionable: "Áp dụng được ngay",
  actionableP: "Mỗi bài viết đều kết thúc bằng các bước bạn có thể thực hiện trong Banana Cards.",
};

export const VIEW_DICT_EN = {
  home: "Home",
  articles: "Articles",
  subcategories: "Subcategories",
  articlesInCategory: "Articles in this category",
  relatedReading: "Related reading",
  by: "By",
  minRead: (m: number) => `${m} min read`,
  updatedOn: (d: string) => `Updated ${d}`,
  readAll: "Read all articles",
  ctaTitle: "Ready to try it",
  ctaTitleItalic: "yourself?",
  ctaBody: "Create a free Banana Cards account and put these ideas to work in your own pipeline today.",
  ctaPrimary: "Get started free",
  emptyBody: "No articles here yet — check back soon.",
  articlesCount: (n: number) => (n === 1 ? "1 article" : `${n} articles`),
  inThisArticle: "In this article",
  showAll: (n: number) => `Show all ${n}`,
  showLess: "Show less",
};

export const VIEW_DICT_VI: typeof VIEW_DICT_EN = {
  home: "Trang chủ",
  articles: "Bài viết",
  subcategories: "Danh mục con",
  articlesInCategory: "Bài viết trong danh mục này",
  relatedReading: "Bài viết liên quan",
  by: "Bởi",
  minRead: (m: number) => `${m} phút đọc`,
  updatedOn: (d: string) => `Cập nhật ${d}`,
  readAll: "Xem tất cả bài viết",
  ctaTitle: "Sẵn sàng thử",
  ctaTitleItalic: "chưa?",
  ctaBody: "Tạo tài khoản Banana Cards miễn phí và áp dụng những ý tưởng này vào pipeline của bạn ngay hôm nay.",
  ctaPrimary: "Bắt đầu miễn phí",
  emptyBody: "Chưa có bài viết ở đây — hãy quay lại sớm nhé.",
  articlesCount: (n: number) => (n === 1 ? "1 bài viết" : `${n} bài viết`),
  inThisArticle: "Trong bài viết này",
  showAll: (n: number) => `Xem tất cả ${n}`,
  showLess: "Thu gọn",
};

export const HUB_DICT_EL: typeof HUB_DICT_EN = {
  eyebrow: "Άρθρα Banana Cards",
  title: "Ιδέες, πρακτικοί οδηγοί και",
  titleItalic: "ιστορίες ανάπτυξης",
  intro:
    "Αναλυτικά άρθρα για τη δημιουργία δυνητικών πελατών, τη στρατηγική CRM, τη δικτύωση και τη δημιουργία μιας επιχείρησης που μπορεί πραγματικά να αναπτυχθεί — γραμμένα από την ομάδα μας και επαγγελματίες που χρησιμοποιούν καθημερινά το Banana Cards.",
  searchPlaceholder: "Αναζητήστε άρθρα, θέματα ή λέξεις-κλειδιά…",
  seoLead: "Το ιδανικό μέρος για να μάθετε σύγχρονες τεχνικές πωλήσεων",
  seoP1:
    "Το Banana Cards Articles είναι το σημείο συνάντησης για ιδρυτές, επικεφαλής πωλήσεων και σύγχρονους επαγγελματίες που θέλουν να εξελιχθούν. Κάθε οδηγός απαντά σε ένα σαφές ερώτημα — χωρίς περιττά λόγια και χωρίς λίστες που παριστάνουν τη στρατηγική.",
  seoP2:
    "Από πρακτικούς οδηγούς για ψυχρή προσέγγιση και δημιουργία δυνητικών πελατών με AI, μέχρι δικτύωση σε εκδηλώσεις και διαχείριση ενός ολοκληρωμένου CRM μέσα από το Banana Cards, όλα έχουν σχεδιαστεί για να κλείνετε περισσότερες συμφωνίες και να αναπτύσσεστε ταχύτερα.",
  featured: "Προτεινόμενο άρθρο",
  featuredCta: "Διαβάστε ολόκληρο το άρθρο",
  browseEyebrow: "Περιήγηση ανά θέμα",
  browseTitle: "Εξερευνήστε κάθε",
  browseTitleItalic: "κατηγορία",
  seeAll: (name: string) => `Δείτε όλα τα ${name}`,
  emptyTitle: "Σύντομα θα προστεθούν άρθρα",
  emptyBody: "Δημοσιεύουμε νέα άρθρα κάθε εβδομάδα — επιστρέψτε σύντομα.",
  ctaEyebrow: "Δοκιμάστε το Banana Cards",
  ctaTitle: "Μετατρέψτε την ανάγνωση σε",
  ctaTitleItalic: "έσοδα",
  ctaBody:
    "Κάθε πρακτικός οδηγός που διαβάζετε εδώ βασίζεται στην πλατφόρμα Banana Cards. Δημιουργήστε δωρεάν λογαριασμό και αρχίστε να εφαρμόζετε όσα μάθατε σήμερα.",
  ctaPrimary: "Ξεκινήστε δωρεάν",
  ctaSecondary: "Δείτε περισσότερα άρθρα",
  articlesCount: (n: number) => (n === 1 ? "1 άρθρο" : `${n} άρθρα`),
  minRead: (m: number) => `${m} λεπτά ανάγνωσης`,
  by: "Από",
  whyBanana: "Γιατί να διαβάσετε τα άρθρα του Banana Cards",
  whyBananaP: "",
  writtenByExperts: "Γραμμένα από επαγγελματίες του χώρου",
  writtenByExpertsP: "Όχι γενικόλογο περιεχόμενο — πραγματικοί πρακτικοί οδηγοί από ομάδες που κάνουν πράξη τις ιδέες τους σήμερα.",
  updatedRegularly: "Πάντα επίκαιρα",
  updatedRegularlyP: "Νέοι οδηγοί κάθε εβδομάδα και ανανεώσεις παλαιότερων άρθρων καθώς εξελίσσονται οι τακτικές.",
  actionable: "Πάντα εφαρμόσιμα",
  actionableP: "Κάθε άρθρο ολοκληρώνεται με βήματα που μπορείτε να εφαρμόσετε μέσα στο Banana Cards.",
};

export const VIEW_DICT_EL: typeof VIEW_DICT_EN = {
  home: "Αρχική",
  articles: "Άρθρα",
  subcategories: "Υποκατηγορίες",
  articlesInCategory: "Άρθρα σε αυτή την κατηγορία",
  relatedReading: "Σχετικά άρθρα",
  by: "Από",
  minRead: (m: number) => `${m} λεπτά ανάγνωσης`,
  updatedOn: (d: string) => `Ενημερώθηκε ${d}`,
  readAll: "Διαβάστε όλα τα άρθρα",
  ctaTitle: "Έτοιμοι να το δοκιμάσετε",
  ctaTitleItalic: "και εσείς;",
  ctaBody: "Δημιουργήστε δωρεάν λογαριασμό Banana Cards και εφαρμόστε σήμερα αυτές τις ιδέες στο δικό σας pipeline.",
  ctaPrimary: "Ξεκινήστε δωρεάν",
  emptyBody: "Δεν υπάρχουν ακόμη άρθρα εδώ — επιστρέψτε σύντομα.",
  articlesCount: (n: number) => (n === 1 ? "1 άρθρο" : `${n} άρθρα`),
  inThisArticle: "Σε αυτό το άρθρο",
  showAll: (n: number) => `Εμφάνιση και των ${n}`,
  showLess: "Εμφάνιση λιγότερων",
};
